






























































import Vue, { PropType } from 'vue'
import UiBadge from '../../UiBadge'
import UiImage from '../../UiImage'
import { SeriesInfoData, SeriesInfoImage } from '../UiSeriesInfo.types'

export default Vue.extend({
  name: 'UiSeriesBanner',
  components: {
    UiBadge,
    UiImage
  },
  props: {
    content: {
      type: Object as PropType<SeriesInfoData>,
      required: true
    },
    image: {
      type: Object as PropType<SeriesInfoImage>,
      default: () => { return {} as SeriesInfoImage }
    },
    warrantyIcon: {
      type: Object as PropType<SeriesInfoImage>,
      default: () => { return {} as SeriesInfoImage }
    }
  },
  computed: {
    isReversed (): boolean {
      return this.image.alignment === 'left'
    }
  }
})
